document.addEventListener("DOMContentLoaded", function () {
  function show(id) {
    const m = document.getElementById(id);
    if (m) m.style.display = 'flex';
  }

  let shown = false;

  // 1. Query params (PRG) têm prioridade
  const params = new URLSearchParams(window.location.search);
  if (params.get('success') === '1') {
    show('modal-success');
    shown = true;
  } else if (params.get('error') === '1') {
    show('modal-error');
    shown = true;
  }
  // Limpa parâmetros para evitar reexibição em reload manual
  if (params.has('success') || params.has('error')) {
    params.delete('success');
    params.delete('error');
    const newQs = params.toString();
    const cleanUrl = window.location.pathname + (newQs ? '?' + newQs : '');
    window.history.replaceState({}, '', cleanUrl);
  }

  // 2. Fallback: marcador data-form-status (caso JS do redirect não rodou)
  if (!shown) {
    const statusEl = document.querySelector('[data-form-status]');
    if (statusEl) {
      const status = statusEl.getAttribute('data-form-status');
      if (status === 'success') show('modal-success');
      else if (status === 'error') show('modal-error');
    }
  }

  // Fecha clicando no botão "X"
  document.querySelectorAll('.close-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const m = this.closest('.modal');
      if (m) m.style.display = 'none';
    });
  });

  // Fecha clicando fora do conteúdo
  document.querySelectorAll('.modal').forEach((modal) => {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
  });
});
